<template>
  <div class="tabStyleBtn-area clearfix">
    <div class="tabStyleBtn-select">
      <label for="tabStyleBtnSelectOptipn">{{ tabMenuActiveItem }}</label>
    </div>
    <input type="checkbox" name="" id="tabStyleBtnSelectOptipn">
    <div class="tabStyleBtn-select-optipn" @click="closeMenu">
      <router-link v-for="item in items"
                   :key="item.name"
                   tag="div"
                   :class="'tabStyleBtn'"
                   exact-active-class="active"
                   :to="item.route"
                   exact>
        <a href="javascript:;" :title="item.name">{{ item.name }}</a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    tabMenuActiveItem: String
  },
  methods: {
    closeMenu: () => document.querySelector('.tabStyleBtn-select>label').click()
  }
}
</script>
